import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Usuario/usuario';
import UsuariosGrid from './UsuariosGrid';

const mstp = state => {
    return {...state.usuario}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(UsuariosGrid)
